// frontend/src/config/api.js
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';